<template>
  <v-hover v-slot="{ hover }" open-delay="200">
    <v-card :class="{ 'on-hover': hover }" class="mx-auto text-left pd10">
      <v-img
        :src="playlistThumbnail"
        v-if="playlistThumbnail !== ''"
        gradient="to top right, rgba(0,0,0,.70), rgba(25,32,72,.7)"
      >
        <v-chip
          v-if="playlist.is_completed"
          class="ma-2"
          color="yellow darken-3"
          dark
          small
        >
          <v-avatar left class="yellow darken-4">
            <i class="fas fa-badge-check m-1"></i>
          </v-avatar>
          Completed
        </v-chip>

        <v-chip
          v-if="hover"
          class="ma-2 card-menu"
          style="background-color: black !important"
          dark
          default
        >
          <div class="menu-option">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  right
                  dark
                  class="m-1"
                  style="
                    font-size: 1.3rem;
                    margin: 6px !important;
                    cursor: pointer;
                  "
                  @click="showSharePlaylist = true"
                >
                  fal fa-share-alt
                </v-icon>
              </template>
              <span style="font-size: 0.9rem">Share</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  right
                  dark
                  class="m-1"
                  style="
                    font-size: 1.3rem;
                    margin: 6px !important;
                    cursor: pointer;
                  "
                  @click="showAssignPlaylist = true"
                >
                  fal fa-users
                </v-icon>
              </template>
              <span style="font-size: 0.9rem">Assign</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-if="user.id == playlist.user_id"
                  v-bind="attrs"
                  v-on="on"
                  right
                  dark
                  class="m-1"
                  style="
                    font-size: 1.3rem;
                    margin: 6px !important;
                    cursor: pointer;
                  "
                  @click="toggleDeleteConfirmation"
                  :loading="deleteLoader"
                  :disabled="deleteLoader"
                >
                  fal fa-trash
                </v-icon>
              </template>
              <span style="font-size: 0.9rem">Delete</span>
            </v-tooltip>
          </div>
        </v-chip>
        <delete-confirm
          :toggleDeleteConfirmation="toggleDeleteConfirmation"
          :deleteConfirmDialog="deleteConfirmDialog"
          :deletePlaylist="deletePlaylist"
          :isLoading="deleteLoader"
        />
        <share-playlist
          v-model="showSharePlaylist"
          :playlists="playlists"
          :id="playlist.id"
        />
        <assign-playlist
          v-model="showAssignPlaylist"
          :playlists="playlists"
          :id="playlist.id"
        />
        <v-chip
          v-if="hover"
          class="ma-2 btn-open-playlist text-uppercase"
          color="yellow darken-3"
          dark
          small
          outlined
          label
          style="background-color: #f9a825 !important; color: white !important"
          :to="{ name: 'Playlist', params: { id: playlist.id } }"
        >
          open playlist
          <div class="right">
            <i class="fas fa-angle-double-right m-1"></i>
          </div>
        </v-chip>
      </v-img>
      <div
        v-else
        class="empty-playlist d-flex flex-wrap justify-center align-center"
      >
        <h4>Empty playlist..</h4>
      </div>
      <v-card-subtitle class="text-left" style="padding: 8px 0 0 0 !important">
        <h3
          class="playlist-heading mt-2 text-uppercase"
          style="font-size: 1.2rem !important"
        >
          {{ playlist.name }}
        </h3>
        <div v-if="showAssignedInfo">
          <strong>Assigned by: {{ assignedPlaylist.user.name }}</strong>
          <p v-show="assignedPlaylist.due_date !== null">
            Due Date: {{ dueDate }}
          </p>
        </div>
      </v-card-subtitle>
    </v-card>
  </v-hover>
</template>
<script>
import dayjs from 'dayjs';
import DeleteConfirm from '../playlist/DeleteConfirm.vue';
import SharePlaylist from './dialog-box/SharePlaylist.vue';
import AssignPlaylist from './dialog-box/AssignPlaylist.vue';
export default {
  props: {
    playlist: Object,
  },
  data: () => ({
    deleteLoader: false,
    deleteConfirmDialog: false,
    showSharePlaylist: false,
    showAssignPlaylist: false,
  }),
  components: {
    DeleteConfirm,
    SharePlaylist,
    AssignPlaylist,
  },
  computed: {
    playlistThumbnail() {
      const { units } = this.playlist;

      if (units === undefined || units.length < 1) {
        return '';
      }

      // fetch random unit
      const unit = units[Math.floor(Math.random() * units.length)];

      return unit.thumbnail;
    },
    user() {
      return this.$auth.user();
    },
    showAssignedInfo() {
      return this.playlist.user_id !== this.user.id;
    },
    assignedPlaylist() {
      return this.playlist.assigned_playlist[0];
    },
    dueDate() {
      return dayjs(this.assignedPlaylist.due_date).format('MM/DD/YYYY');
    },
    playlists() {
      return this.$store.state.lmsClient.playlists;
    },
  },
  methods: {
    deletePlaylist() {
      this.deleteLoader = true;
      this.$store
        .dispatch('playlist/deletePlaylist', this.playlist.id)
        .then(() => {
          this.toggleDeleteConfirmation();
          this.deleteLoader = false;
          this.$notify('success', 'Playlist removed!');
          this.$store.dispatch('lmsClient/deletePlaylist', this.playlist.id);
        })
        .catch(() => {
          this.deleteLoader = false;
          console.log(
            'Encountered an error while loading the playlists. Please try again'
          );
        });
    },
    toggleDeleteConfirmation() {
      this.deleteConfirmDialog = !this.deleteConfirmDialog;
    },
  },
};
</script>

<style scoped lang="stylus">
.empty-playlist
  width 100%
  height 200px
  background #fff
.v-image
  height: 200px;
  max-width: 100% !important;
  width: auto;
  z-index: 0;
</style>
